import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const FileIconOneLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 17H9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13H13"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 14C20.5 17.7712 20.5 19.6569 19.2552 20.8284C18.0104 22 16.0069 22 12 22H11.2273C7.96607 22 6.33546 22 5.20307 21.2022C4.87862 20.9736 4.59058 20.7025 4.3477 20.3971C3.5 19.3313 3.5 17.7966 3.5 14.7273V12.1818C3.5 9.21865 3.5 7.73706 3.96894 6.55375C4.72281 4.65142 6.31714 3.15088 8.33836 2.44135C9.59563 2 11.1698 2 14.3182 2C16.1173 2 17.0168 2 17.7352 2.2522C18.8902 2.65765 19.8012 3.5151 20.232 4.60214C20.5 5.27832 20.5 6.12494 20.5 7.81818V14Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12C3.5 10.1591 4.99238 8.66667 6.83333 8.66667C7.49912 8.66667 8.28404 8.78333 8.93137 8.60988C9.50652 8.45576 9.95576 8.00652 10.1099 7.43136C10.2833 6.78404 10.1667 5.99912 10.1667 5.33333C10.1667 3.49238 11.6591 2 13.5 2"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileIconOne: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33527 6.66671C2.33527 4.15255 2.33527 2.89547 3.16513 2.11442C3.99499 1.33337 5.33064 1.33337 8.00193 1.33337H8.51707C10.6912 1.33337 11.7783 1.33337 12.5332 1.86527C12.7495 2.01766 12.9415 2.19839 13.1035 2.40197C13.6686 3.11249 13.6686 4.13561 13.6686 6.18186V7.87884C13.6686 9.85431 13.6686 10.842 13.356 11.6308C12.8534 12.8991 11.7905 13.8994 10.443 14.3724C9.60487 14.6667 8.5554 14.6667 6.45648 14.6667C5.2571 14.6667 4.65741 14.6667 4.17845 14.4986C3.40846 14.2283 2.8011 13.6566 2.51391 12.932C2.33527 12.4812 2.33527 11.9168 2.33527 10.7879V6.66671Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13.6686 8C13.6686 9.22727 12.6737 10.2222 11.4464 10.2222C11.0026 10.2222 10.4793 10.1445 10.0477 10.2601C9.66429 10.3628 9.36475 10.6623 9.26202 11.0457C9.14642 11.4773 9.22415 12.0006 9.22415 12.4445C9.22415 13.6717 8.22922 14.6667 7.00195 14.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33527 4.66663H10.0019"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33527 7.33337H7.33527"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileFinanceIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3338 6.60671V5.21277C13.3338 4.08394 13.3338 3.51953 13.1552 3.06874C12.868 2.34405 12.2606 1.77242 11.4906 1.50212C11.0116 1.33398 10.412 1.33398 9.21255 1.33398C7.11369 1.33398 6.06418 1.33398 5.226 1.62822C3.87851 2.10124 2.81563 3.1016 2.31305 4.36982C2.00043 5.15869 2.00043 6.14642 2.00043 8.12185V9.81885C2.00043 11.8651 2.00043 12.8882 2.56556 13.5987C2.72748 13.8023 2.91951 13.9831 3.13581 14.1355C3.89073 14.6673 4.9778 14.6673 7.15195 14.6673H7.66715C8.02355 14.6673 8.68962 14.6673 9.00049 14.6655M2.00043 8.00065C2.00043 6.77332 2.99535 5.77843 4.22265 5.77843C4.6665 5.77843 5.18978 5.8562 5.62133 5.74057C6.00477 5.63782 6.30427 5.33833 6.40701 4.95489C6.52264 4.52334 6.44487 4.00006 6.44487 3.5562C6.44487 2.3289 7.43982 1.33398 8.66715 1.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8351 10.5401C13.905 9.69708 12.6152 9.00875 11.6295 9.47062C10.3982 10.0475 10.5056 11.5056 12.0263 11.5827C12.703 11.617 13.295 11.5439 13.6972 11.9799C14.0995 12.4159 14.2738 13.5261 13.0881 13.9029C11.9023 14.2796 10.6664 13.6077 10.6664 12.7881M12.3138 8.66602V9.31782M12.3138 14.1463V14.666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FileAdminIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5339 7.33203C13.5339 7.33203 13.5339 6.28576 13.4324 6.04074C13.3309 5.79571 13.1382 5.60302 12.7528 5.21765L9.59512 2.05995C9.26252 1.72736 9.09625 1.56106 8.89019 1.46253C8.84732 1.44203 8.80345 1.42384 8.75865 1.40804C8.54325 1.33203 8.30812 1.33203 7.83772 1.33203C5.6744 1.33203 4.59273 1.33203 3.86007 1.92274C3.71206 2.04208 3.57724 2.1769 3.4579 2.32492C2.86719 3.05757 2.86719 4.13924 2.86719 6.30259V9.33203C2.86719 11.8462 2.86719 13.1033 3.64823 13.8843C4.42929 14.6654 5.68636 14.6654 8.20052 14.6654M8.86719 1.66536V1.9987C8.86719 3.88432 8.86719 4.82712 9.45299 5.41291C10.0388 5.9987 10.9816 5.9987 12.8672 5.9987H13.2005"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3257 9.95466L12.9106 9.53958C12.6339 9.26285 12.1852 9.26285 11.9085 9.53957L9.81394 11.708C9.63387 11.8945 9.5332 12.1436 9.5332 12.4028V13.332H10.4625C10.7217 13.332 10.9707 13.2314 11.1572 13.0513L13.3257 10.9568C13.6024 10.68 13.6024 10.2314 13.3257 9.95466Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FilesIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6673 12.6673H8.33397C6.44836 12.6673 5.50556 12.6673 4.91977 12.0815C4.33398 11.4957 4.33398 10.5529 4.33398 8.66732V5.33398C4.33398 3.44836 4.33398 2.50556 4.91977 1.91977C5.50556 1.33398 6.44836 1.33398 8.33397 1.33398H9.22944C9.77444 1.33398 10.0469 1.33398 10.292 1.43548C10.537 1.53697 10.7296 1.72966 11.115 2.11503L12.8862 3.88627C13.2716 4.27164 13.4643 4.46433 13.5658 4.70936C13.6673 4.95438 13.6673 5.22688 13.6673 5.77188V8.66732C13.6673 10.5529 13.6673 11.4957 13.0815 12.0815C12.4958 12.6673 11.5529 12.6673 9.6673 12.6673Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1.66602V2.33268C10 3.58976 10 4.2183 10.3905 4.60882C10.7811 4.99935 11.4096 4.99935 12.6667 4.99935H13.3333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33398 3.33398C3.22942 3.33398 2.33398 4.22942 2.33398 5.33398V10.6673C2.33398 12.553 2.33398 13.4958 2.91977 14.0815C3.50556 14.6673 4.44836 14.6673 6.33398 14.6673H9.66757C10.7721 14.6673 11.6676 13.7719 11.6676 12.6673"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 7.33398H9.33268M6.66602 10.0007H11.3327"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
